import { render, staticRenderFns } from "./PurchaseOrdersPage.vue?vue&type=template&id=2e338484"
import script from "./PurchaseOrdersPage.vue?vue&type=script&lang=js"
export * from "./PurchaseOrdersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports